export default {"src":"/_next/static/media/react.d60a0182.svg","height":2500,"width":2194,"blurWidth":0,"blurHeight":0};